// "Awakened" symbols (32×32, id sym_<id>) and Scratch-of-Fate prize icons (24×24).
// Style matches symbols.ts: 1-px ink outline, light from top-left, readable by silhouette.
// Key: '.' transparent, 'o' ink outline, other chars per sprite.
import { sprite, type SpriteDef } from './types';

export const heart = sprite(
  'sym_heart',
  {
    o: 'ink',
    s: 'salmonPink',
    w: 'wine',
    c: 'crimson',
    C: 'cerise',
    r: 'rose',
    d: 'dustyPink',
    a: 'coral',
    R: 'red',
    W: 'white',
    b: 'blood',
  },
  [
    '................................',
    '...............oooo.............',
    '..........ooo.oswwco............',
    '.........owwwoosCCco............',
    '.........osCcoosCCco.oo.........',
    '.........osCCcosCCcoorro........',
    '.........ocCCcosCCcooddo........',
    '........ooooCcosCCcooddo........',
    '.......oaaaaooosCooRRooRo.......',
    '......oaaaaaaaaooRRRcRRRRo......',
    '.....oaaaaWWWaaaRRRRcRRRRRo.....',
    '.....oaaaaWWWaaRRRRRRcRRRRo.....',
    '....oaaaaaaaaaaRRRRRRcRRRRbo....',
    '....oaaaaaaaaaRRRRRRcRccRbbo....',
    '....oaaaaaaaaRRRRRRRcRRRbbbo....',
    '.....oaaaaaaRRRRRRRcRRRbbbo.....',
    '.....oaaaaaRRRRRRRRRcRRbbbo.....',
    '......oaaaRRRRRRRRRRcRbbbo......',
    '.......oaRRRRRRRRRRRRcbbo.......',
    '........oRRRRRRRRRRRbcbo........',
    '.........oRRRRRRRRRbbco.........',
    '..........oRRRRRRRbbco..........',
    '...........oRRRRRbbbco..........',
    '...........oRRRRbbbbo...........',
    '............oRRbbbbo............',
    '.............obbbbo.............',
    '..............obbo..............',
    '...............oo...............',
    '................................',
    '................................',
    '................................',
    '................................',
  ],
);

export const candle = sprite(
  'sym_candle',
  {
    o: 'ink',
    O: 'orange',
    g: 'gold',
    l: 'lemon',
    w: 'white',
    L: 'lilacGrey',
    s: 'steel',
    p: 'paper',
    b: 'brass',
    B: 'brick',
    r: 'bronze',
  },
  [
    '................................',
    '................................',
    '...............oo...............',
    '..............oOOo..............',
    '..............oOOo..............',
    '.............oOggOo.............',
    '.............oOggOo.............',
    '............oOOggOOo............',
    '............oOgllgOo............',
    '............oOgllgOo............',
    '.............oOggOo.............',
    '..............oooo..............',
    '..........oooooooooooo..........',
    '.........owwwwwwwwwwLLo.........',
    '.........owwwwssssssLLo.........',
    '.........owwwwppppswLLo.........',
    '.........owwwwpppssLLo..........',
    '.........owwwwpppssLLo..........',
    '.........owwwwpppssLLo..........',
    '..........owwwppppssLo..........',
    '..........owwwppppssLo..........',
    '..........owwwppppssLo..........',
    '..........owwwppppssLo..........',
    '..........owwwppppssLo..........',
    '..........owwwppppssLo..........',
    '.......oooowwwppppssLoooo.......',
    '.....oobbbboooooooooobbbBoo.....',
    '....obbrrrrrrrrrrrrrrrrrrbBo....',
    '....oBBBrrrrrrrrrrrrrrrrBBBo....',
    '.....oooBBBBBBBBBBBBBBBBooo.....',
    '........oooooooooooooooo........',
    '................................',
  ],
);

export const wax = sprite(
  'sym_wax',
  { o: 'ink', l: 'lilacGrey', d: 'dusk', c: 'charcoal', w: 'white', p: 'paper', s: 'steel' },
  [
    '................................',
    '................................',
    '................................',
    '.....................l..........',
    '....................d...........',
    '...................d............',
    '...................d............',
    '....................d...........',
    '....................d...........',
    '...................d............',
    '................................',
    '.................oo.............',
    '................oco.............',
    '...............oco..............',
    '...............oco..............',
    '...............oco..............',
    '..............oocoo.............',
    '.............owopplo............',
    '............owowwpslo...........',
    '.............owwppsloo..........',
    '...........oowwwpppsolo.........',
    '.......oo.owowwwpppssllooooo....',
    '.....oowwowowoooooooslowwwwlo...',
    '....owwppoooowwpppppoloppppplo..',
    '...owpppppwwwwwppppppopppppplo..',
    '...owppppppppppppppppppppppplo..',
    '...owpppppppppppppppppppplllo...',
    '...ollllpllppppppppppllllooo....',
    '....ooooloolllllllllloooo.......',
    '........o..oooooooooo...........',
    '................................',
    '................................',
  ],
);

export const moth = sprite(
  'sym_moth',
  {
    o: 'ink',
    m: 'mauveGrey',
    k: 'khaki',
    c: 'cream',
    s: 'sand',
    d: 'dusk',
    p: 'paper',
    l: 'lilacGrey',
    n: 'night',
    P: 'plumGrey',
  },
  [
    '................................',
    '...........o........o...........',
    '....o.....oo........oo.....o....',
    '...omooo....o.......o...ooomo...',
    '...okkkmooooo......ooooomkkko...',
    '..okccsskkmo.o....o.omkkssccko..',
    '..oksssssssmoo.oo.oomsssssssko..',
    '.omcsssdddssmooddoomssdddssscmo.',
    '..okssspddssmodlddomssddpsssko..',
    '..oksssdddsssmoddomsssdddsssko..',
    '..oksssdddssssmoomssssdddsssko..',
    '..okssssssssssmoomssssssssssko..',
    '..okmmsssssmmsoddosmmsssssmmko..',
    '..omssmmmmmsssonnosssmmmmmssmo..',
    '...omsssssssssoddosssssssssmo...',
    '....ommsssssssoddosssssssmmo....',
    '.....oommooooolnnnooooommoo.....',
    '.......oosssssoddosssssoo.......',
    '.......osmmmmmoddommmmmso.......',
    '......osmmmmmmonnommmmmmso......',
    '.....osmmmmmmmoddommmmmmmso.....',
    '....oPmmmPmmmmoddommmmPmmmPo....',
    '.....osmPcPmmmonnommmPcPmso.....',
    '.....osmPPPmmPoddoPmmPPPmso.....',
    '.....osmmPmmPoolnooPmmPmmso.....',
    '.....oPmmmmPo.onno.oPmmmmPo.....',
    '......oPPPPo...oo...oPPPPo......',
    '.......oooo..........oooo.......',
    '................................',
    '................................',
    '................................',
    '................................',
  ],
);

export const lantern = sprite(
  'sym_lantern',
  { o: 'ink', b: 'bronze', m: 'maroon', c: 'copper', l: 'lemon', g: 'gold', a: 'amber', O: 'orange' },
  [
    '................................',
    '...............oo...............',
    '.............oobmoo.............',
    '............obmmmmmo............',
    '............omoooomo............',
    '...........obmoooobmo...........',
    '...........ommobbommo...........',
    '............ooccccoo............',
    '...........obccccccmo...........',
    '..........obccccccccmo..........',
    '.........ommmmmmmmmmmmo.........',
    '........obbbbbbbbbbbbbmo........',
    '........obcmmmmbbmmmmcmo........',
    '........obmlggllllggabmo........',
    '........obmlgllllllgabmo........',
    '........obmlllllllllabmo........',
    '........obmllllOOlllabmo........',
    '........obmllllOOlllabmo........',
    '........obmglllOOlllabmo........',
    '........obmgllOllOllabmo........',
    '........obmgllllllllabmo........',
    '........obmggllllllgabmo........',
    '........obmgggllllggabmo........',
    '.......omoooooooooooooomo.......',
    '........obccccccccccccmo........',
    '........obccccccccccccmo........',
    '........omoccccccccccomo........',
    '.........ommmmmmmmmmmmo.........',
    '..........oooooooooooo..........',
    '................................',
    '................................',
    '................................',
  ],
);

export const match = sprite(
  'sym_match',
  {
    o: 'ink',
    O: 'orange',
    g: 'gold',
    l: 'lemon',
    v: 'vermilion',
    r: 'red',
    c: 'coral',
    b: 'blood',
    C: 'cream',
    s: 'sand',
    m: 'mauveGrey',
  },
  [
    '................................',
    '...................o............',
    '..................oOo...........',
    '..................ogOo..........',
    '.................oOgOo..........',
    '.................oOgOo..........',
    '................oOgggOo.........',
    '................oOgggOo.........',
    '...............oOggggOo.........',
    '...............oOgllgOo.........',
    '..............oOgllllgOo........',
    '...............ogllllgo.........',
    '...............oOooogOo.........',
    '...............oovrroo..........',
    '..............ovcrrrro..........',
    '..............ovrrrrbo..........',
    '..............orrrrbbo..........',
    '..............oorrbbo...........',
    '.............oCsobbo............',
    '............oCsmooo.............',
    '...........oCsmo................',
    '..........oCsmo.................',
    '.........oCsmo..................',
    '........oCsmo...................',
    '.......oCsmo....................',
    '......oCsmo.....................',
    '.....oCsmo......................',
    '.....ommo.......................',
    '......oo........................',
    '................................',
    '................................',
    '................................',
  ],
);

export const chalice = sprite(
  'sym_chalice',
  {
    o: 'ink',
    l: 'lemon',
    b: 'brass',
    w: 'wine',
    a: 'amber',
    c: 'copper',
    B: 'blood',
    g: 'gold',
    C: 'coral',
    r: 'red',
  },
  [
    '................................',
    '................................',
    '................................',
    '.........oooooooooooooo.........',
    '.......oolllllllllllllloo.......',
    '.....oobbblwwwwwwwwwwaaccoo.....',
    '....obbwwBBBBwwwwwwwwwwwwcco....',
    '.....obbbllwwwwwwwwwwaaacco.....',
    '.....obbbllbggggggggaaaacco.....',
    '.....obbbllbggggggggaaaacco.....',
    '.....obbbllbggggggggaaaacco.....',
    '......obbbllgggBBggaaaacco......',
    '......obbbllggBCrBgaaaacco......',
    '.......obblllgBrBBgaaacco.......',
    '........obbllggBBggaacco........',
    '.........obbllggggaacco.........',
    '..........oobllggaacoo..........',
    '............oooooooo............',
    '.............obbaco.............',
    '............olllgaco............',
    '............olllgaco............',
    '.............obbaco.............',
    '............oobbacoo............',
    '...........oblooooaco...........',
    '..........obllggggaaco..........',
    '........oobbllggggaaccoo........',
    '.......obblllggggggaaacco.......',
    '.......obblllggggggaaacco.......',
    '........oooooooooooooooo........',
    '................................',
    '................................',
    '................................',
  ],
);

export const hourglass = sprite(
  'sym_hourglass',
  {
    o: 'ink',
    c: 'copper',
    m: 'maroon',
    b: 'brick',
    w: 'white',
    p: 'paper',
    s: 'steel',
    B: 'brass',
    g: 'gold',
    a: 'amber',
  },
  [
    '................................',
    '................................',
    '......oooooooooooooooooooo......',
    '.....occcccccccccccccccccmo.....',
    '.....ocbbbbbbbbbbbbbbbbbbmo.....',
    '.....ommmmmmmmmmmmmmmmmmmmo.....',
    '......oooooooooooooooooooo......',
    '......ocbowwwppppppsssocbo......',
    '......ocbowwwppppppsssocbo......',
    '......ocbowwwppppppsssocbo......',
    '......ocmowwwppppppsssocmo......',
    '......ocbooBBBBBBBBBBoocbo......',
    '......ocbo.oggggggggo.ocbo......',
    '......ocbo..oggggggo..ocbo......',
    '......ocbo...oggggo...ocbo......',
    '......ocmo...owgpso...ocmo......',
    '......ocbo...owgpso...ocbo......',
    '......ocbo...owgpso...ocbo......',
    '......ocbo..owwgpsso..ocbo......',
    '......ocbo.owwpgppsso.ocbo......',
    '......ocmoowwppBapsssoocmo......',
    '......ocboowwwBggapsssocbo......',
    '......ocbowwBBggggBassocbo......',
    '......ocboBBggggggggBaocbo......',
    '......ocboaaaaaaaaaaaaocbo......',
    '......oooooooooooooooooooo......',
    '.....occcccccccccccccccccmo.....',
    '.....ocbbbbbbbbbbbbbbbbbbmo.....',
    '.....ommmmmmmmmmmmmmmmmmmmo.....',
    '......oooooooooooooooooooo......',
    '................................',
    '................................',
  ],
);

export const key = sprite(
  'sym_key',
  { o: 'ink', b: 'bronze', m: 'maroon', B: 'brass', c: 'copper', r: 'brick' },
  [
    '.........oo.....................',
    '........obmo....................',
    '...ooo.obbbmo...................',
    '..obbmoobbbmo...................',
    '..obbbbbbbbmo...................',
    '..ombBBBbbccmo..................',
    '...obBBBrrrccmo.................',
    '..oobBBrooorccmo................',
    '.obbbbro...orcmo................',
    'obbbbbro...orcmo................',
    'ombbbcro...orrmo................',
    '.ommmccrooorrrmoo...............',
    '..ooomccrrrrrrmomo..............',
    '.....omcccrrrcoco...............',
    '......ommmmmmocomo..............',
    '.......oooooococcmo.............',
    '...........omomcccmo............',
    '............o.omcccmo...........',
    '...............omcccmo..........',
    '................omcccmo.........',
    '.................obcccmo........',
    '................obcccccmo.......',
    '...............obcccccccmo......',
    '..............omccmccccccmo.....',
    '...............ommomccccccmo....',
    '................oo.obcccccmo....',
    '...................obccmmmmo....',
    '..................omccmoooo.....',
    '...................ommo.........',
    '....................oo..........',
    '................................',
    '................................',
  ],
);

export const lock = sprite(
  'sym_lock',
  { o: 'ink', p: 'paper', d: 'dusk', s: 'steel', w: 'white', b: 'brass', a: 'amber', c: 'copper', g: 'gold' },
  [
    '................................',
    '................................',
    '................................',
    '................................',
    '............oooooooo............',
    '...........opppppppdo...........',
    '..........opssssssssdo..........',
    '.........opssddddddssdo.........',
    '.........opsdoooooopsdo.........',
    '........opwsdo....odssdo........',
    '........opwdo......opsdo........',
    '........opwdo......opsdo........',
    '........opwdo......opsdo........',
    '.......oopwdoooooooopsdoo.......',
    '......obbooobbbbbbbboooaco......',
    '.....obgggggggggggggggggaco.....',
    '.....obbbbbbbbbbbbbbbbbbbco.....',
    '.....obaaaaaaaaaaaaaaaaaaco.....',
    '.....obgggggggggggggggggaco.....',
    '.....obgcggggggooggggggcaco.....',
    '.....obgggggggooooggggggaco.....',
    '.....obgggggggooooggggggaco.....',
    '.....obggggggggoogggggggaco.....',
    '.....obggggggggoogggggggaco.....',
    '.....obggggggggoogggggggaco.....',
    '.....oagcggggggggggggggcaco.....',
    '.....ocaaaaaaaaaaaaaaaaaaco.....',
    '......occcccccccccccccccco......',
    '.......oooooooooooooooooo.......',
    '................................',
    '................................',
    '................................',
  ],
);

export const egg = sprite(
  'sym_egg',
  { o: 'ink', l: 'lime', p: 'pistachio', O: 'olive', r: 'rose', L: 'lemon', f: 'flesh', m: 'moss' },
  [
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '..............ooo...............',
    '............oolllooo............',
    '...........olllllollo...........',
    '..........ollllllloppo..........',
    '.........olllllOlloorro.........',
    '........ollLLllllfOpoopo........',
    '.......ollLLrLllopppppppo.......',
    '.......olrLLLLlpporpOpppo.......',
    '......olllLLLLppppopprpppo......',
    '......orlllLlOppppfoppppmo......',
    '......olllllpppppppopprmmo......',
    '......olllllppppppopppmmmo......',
    '......olllOOpppppppppmmmmo......',
    '......olllOpppppppppmmmmmo......',
    '......orlppppppppppmmmmmmo......',
    '......olppppppppppOmmmmmmo......',
    '......oppppppppprpmrmmmmOo......',
    '.......opppppppprmmmmmmOo.......',
    '.......oppppppppmmOOmmOOo.......',
    '........oppppOpmmmmmmOOo........',
    '.........oOpppmmmmmmOOo.........',
    '..........oppmmmmmmOOo..........',
    '...........oommmmmOoo...........',
    '.............oooooo.............',
    '................................',
    '................................',
  ],
);

export const seed = sprite(
  'sym_seed',
  {
    o: 'ink',
    l: 'leaf',
    f: 'forest',
    c: 'clover',
    b: 'bronze',
    C: 'copper',
    B: 'brass',
    r: 'brick',
    s: 'sand',
  },
  [
    '................................',
    '................................',
    '................................',
    '.......................ooooo....',
    '......................ollllfo...',
    '.....................olcccffo...',
    '...................oolccffcfo...',
    '..................ollcffcccfo...',
    '..................olcfccccfo....',
    '..................olfccccfo.....',
    '.................ococccffo......',
    '................ocoffffoo.......',
    '................occoooo.........',
    '...............occco............',
    '...............occo.............',
    '..............olcco.............',
    '..............olco..............',
    '..............olco..............',
    '..............olco..............',
    '.............oolcooo............',
    '...........oobboobCCo...........',
    '..........oBBBbbrrCCCo..........',
    '.........obBrrrrCCCCCCo.........',
    '........obrrbCCCCCCCrro.........',
    '........obbbCCCCCCCrrro.........',
    '........obCCCCCCCrrrro..........',
    '.........oCCCCCCrrrro...........',
    '..........oCCCrrrroo............',
    '...........oosoooo..............',
    '............s...s...............',
    '.................s..............',
    '................................',
  ],
);

export const ghost = sprite(
  'sym_ghost',
  { o: 'ink', w: 'white', p: 'paper', n: 'night', P: 'pinkLilac', s: 'steel' },
  [
    '................................',
    '................................',
    '................................',
    '............oooooooo............',
    '..........oowwwwwwwwoo..........',
    '.........owwwwwwwwwwwwo.........',
    '........owwwwwwwwwwwwwwo........',
    '........owwwwwwwwwwwwwwo........',
    '.......owwwwwwwwwwwwwwwwo.......',
    '.......owwwwwwwwwwwwwwwwo.......',
    '......owwwwooowppwooowwwwo......',
    '......owwwwoooppppooowwwwo......',
    '......owwwwoooppppooowwwwo......',
    '......owwwwonopppponowwwwo......',
    '......owwwwoooppppooowwwwo......',
    '...oooowwPppppppppppppPwwoooo...',
    '..owwwwwwwppppppppppppwwwwwwwo..',
    '..owwwwwwppppppppppppppwwwwwwo..',
    '..owwwwwpppppppoopppppppwwwwwo..',
    '...ooowppppppppooppppppppwooo...',
    '.....oppppppppppppppppppppo.....',
    '.....oppppppppppppppppppppo.....',
    '.....oppppppppppppppppppppo.....',
    '.....oppppppppppppppppppppo.....',
    '....oppppppppppssppppppppppo....',
    '....oppppoopppsoospppooppppo....',
    '....oppppoopppsoospppooppppo....',
    '.....oppo..opso..ospo..oppo.....',
    '......oo....oo....oo....oo......',
    '................................',
    '................................',
    '................................',
  ],
);

export const sigScratch = sprite(
  'sym_sig_scratch',
  {
    o: 'ink',
    i: 'ice',
    m: 'mint',
    t: 'teal',
    n: 'neonTeal',
    l: 'lilacGrey',
    s: 'steel',
    p: 'paper',
    c: 'cream',
    O: 'orange',
    L: 'lemon',
    g: 'gold',
    w: 'white',
    d: 'dusk',
  },
  [
    '................................',
    '..i.............................',
    '.iii..........................m.',
    '..i..t.t.t.t.t.t.t.t.t.t.t.t.m..',
    '....oooooooooooooooooooooooot...',
    '...ommmmmmmmmmmmmmmmmmmmmmmnot..',
    '..tomiiiiiiiiiiiiiiiiiiiiitno...',
    '...omilsssspssssssslpssssstnot..',
    '..tomislsspssssssssplssssstno...',
    '...omisslpscsOcccspsslsssstnot..',
    '..tomissplcccOcccccssslssstno...',
    '...omispccccLgOcccscssslsptnot..',
    '..tomipsccccLwOccccssssspstno...',
    '...omisOLLLLwwgLLLLOcsspsltnot..',
    '..tomiccOOgggggggOOccspssstno...',
    '...omiccccOgggggOccccpsssstnot..',
    '..tomisccccLgggOcccccssssstno...',
    '...omiscccLggOggOcccsssssstnot..',
    '..tomiscscLgOcOgOcpssoooootno...',
    '...omisscsOOcccOOccsoppppsonot..',
    '..tomilpsscsccsscssowwlllssoo...',
    '...omiplssssscspsssowlpsswssot..',
    '..tomisslssssspssssolpsssswlo...',
    '...omttttttttttttttolssssswlot..',
    '..tonnnnnnnnnnnnnnnoslssswllo...',
    '...tooooooooooooooossswwwlldot..',
    '....t.t.t.t.t.t.t.tosssllldot...',
    '...................tosllldot.i..',
    '.m..................tooooot.iii.',
    '.....................t.t.t...i..',
    '................................',
    '................................',
  ],
);

export const prize2 = sprite(
  'prize_2',
  { o: 'ink', l: 'lemon', b: 'brass', g: 'gold', O: 'orange', a: 'amber' },
  [
    '........................',
    '........................',
    '........................',
    '........................',
    '........................',
    '........................',
    '........................',
    '........................',
    '........................',
    '........oooooooo........',
    '......oolllllllboo......',
    '.....ollgbbbbbbglbo.....',
    '.....obbgbbbbbbgbbo.....',
    '.....oOabbbbbbbbOao.....',
    '......ooOaOaOaOaoo......',
    '.....obboooooooobbo.....',
    '.....oOabbbbbbbbOao.....',
    '......ooOaOaOaOaoo......',
    '.....obboooooooobbo.....',
    '.....oOabbbbbbbbOao.....',
    '.....oOaOaOaOaOaOao.....',
    '......ooOaOaOaOaoo......',
    '........oooooooo........',
    '........................',
  ],
);

export const prize5 = sprite(
  'prize_5',
  { o: 'ink', l: 'lemon', b: 'brass', g: 'gold', a: 'amber', O: 'orange' },
  [
    '........................',
    '........................',
    '........................',
    '........................',
    '...oooooooo.............',
    '..olllllllbo............',
    '.obggbbbbggbo...........',
    '.oabbbbbbbbao...........',
    '..oaOaOaOaOo............',
    '.oboooooooobo...........',
    '.oabbbbbbbbaooooooooo...',
    '..oaOaOaOaOoolllllllbo..',
    '.obooooooooboggbbbbggbo.',
    '.oabbbbbbbbaobbbbbbbbao.',
    '..oaOaOaOaOoOaOaOaOaOo..',
    '.oboooooooobooooooooobo.',
    '.oabbbbbbbbaobbbbbbbbao.',
    '..oaOaOaOaOoOaOaOaOaOo..',
    '.oboooooooobooooooooobo.',
    '.oabbbbbbbbaobbbbbbbbao.',
    '.oOaOaOaOaOaoaOaOaOaOao.',
    '..oaOaOaOaOooaOaOaOaOo..',
    '...oooooooo..oooooooo...',
    '........................',
  ],
);

export const prize10 = sprite(
  'prize_10',
  { o: 'ink', b: 'brass', l: 'lemon', g: 'gold', a: 'amber', O: 'orange' },
  [
    '........................',
    '........................',
    '........................',
    '........................',
    '...............oo.......',
    '..............obbo......',
    '.............olbggo.....',
    '............oblagggo....',
    '............obbaggao....',
    '...........oobgaggao....',
    '.........ooaaoggaaao....',
    '.......ooalllaogaao.....',
    '.....oobboooooooooo.....',
    '....obbbaaaggaaagggo....',
    '...obbbllllallllagggo...',
    '..obbbbbaaaggaaaggggao..',
    '.obbbbbgggggggggggaaaao.',
    '.obbbaaaggggggggaaaaaao.',
    '.obbllllaggggggllllaaao.',
    'obbaaaaaggaaagaaaaaaaOOo',
    '.oloooaggllllaaaaloooao.',
    '..oaaaogggaaaaaaaoaaao..',
    '...ooo.oooooooooo.ooo...',
    '........................',
  ],
);

export const prize25 = sprite(
  'prize_25',
  { o: 'ink', l: 'lemon', w: 'white', a: 'amber', b: 'brass', g: 'gold', O: 'orange' },
  [
    '........................',
    '........................',
    '........................',
    '........................',
    '...................l....',
    '..................lll...',
    '....l..............l....',
    '........................',
    '........................',
    '........ooooooooooo.....',
    '.......owwwwwwwwwwao....',
    '.....oollllllllllaaao...',
    '....obboooooooooaaaao...',
    '....obgggggggggoaaaao...',
    '....obggOOOOOggoaaaaao..',
    '...obgggaalaagggoaaaao..',
    '...obgggaaaaagggoaaaaOo.',
    '..obgggggggggggggoaaOo..',
    '..obgggggggggggggoaOo...',
    '..oaaaaaaaaaaaaaaaoo....',
    '...ooooooooooooooo....l.',
    '........................',
    '........................',
    '........................',
  ],
);

export const prizeJackpot = sprite(
  'prize_jackpot',
  { o: 'ink', l: 'lemon', a: 'amber', b: 'brass', w: 'white', g: 'gold', r: 'red', B: 'blue' },
  [
    '........................',
    '...........oo...........',
    '..o.......olao.......o..',
    '.obo......olao......obo.',
    '..obo..oooolaoooo..obo..',
    '...obooalllwglllaoobo...',
    '....o..oaggwgggao..o....',
    '........olggggao........',
    '........olggggao........',
    '...oo...olgaagao...oo...',
    '..ollo..oaaooaao..ollo..',
    '.ooolo...oooooo...olooo.',
    'obbbo.....olao.....obbbo',
    '.oooao...olggao...oaooo.',
    '...olao.olggggao.olao...',
    '...olgaolggggggaolgao...',
    '...oagglgggggggglggao...',
    '....olgggggggggggggao...',
    '...oolllllllllllllloo...',
    '.oobobbrrbbBBbbrrbboboo.',
    'obboobbrrbbBBbbrrbboobbo',
    '.oo.oaaaaaaaaaaaaaao.oo.',
    '.....oooooooooooooo.....',
    '........................',
  ],
);

export const scratchEye = sprite(
  'scratch_eye',
  { o: 'ink', w: 'white', p: 'paper', n: 'neonTeal', d: 'deepTeal', r: 'red', t: 'teal', c: 'coral' },
  [
    '.......o...oo...o.......',
    '.......o...oo...o.......',
    '..o....o...oo...o....o..',
    '...o....o..oo...o...o...',
    '...o....o..oo..o....o...',
    '....o...o.oooo.o...o....',
    '....o...oowwwpoo...o....',
    '.....ooowwwwwwwpooo.....',
    '.....owwwwwwwwwwwpo.....',
    'o...owwwwwnnndwwwwpo...o',
    '.o.owwwrwnwtttdwrwcpo.o.',
    '..owwrwrwnwootdwwrwcpo..',
    '.oprrwrwdtooootdwwrwrpo.',
    '..opcwwcwntootdwwwrrpo..',
    '...opccwwdttttdwwwcpo...',
    '....opwwwwddddwwwcpo....',
    '.....oppwwwwwwwwppo.....',
    '......ooppwwwwppoo......',
    '.......oooppppooo.......',
    '.......o..oooo..o.......',
    '.......o...oo....o......',
    '......o....oo....o......',
    '......o....oo....o......',
    '...........oo...........',
  ],
);

export const prizeDud = sprite(
  'prize_dud',
  { o: 'ink', s: 'steel', l: 'lilacGrey', d: 'dusk', p: 'paper' },
  [
    '........................',
    '........................',
    '........................',
    '........................',
    '........................',
    '.........oooooo.........',
    '.......oosppppsoo.......',
    '......ospplllllsdo......',
    '.....ospo......oldo.....',
    '.....opo........odo.....',
    '....osp.oo....oo.odo....',
    '....opl..oo..oo..ldo....',
    '....opl...oooo...ldo....',
    '....opl...oooo...ldo....',
    '....opl..oo..oo..ldo....',
    '....osl.oo....oo.ldo....',
    '.....odo........odo.....',
    '.....osdo......odso.....',
    '......osdlllllldso......',
    '.......oosddddsoo.......',
    '.........oooooo.........',
    '........................',
    '........................',
    '........................',
  ],
);

export const SYMBOL_SPRITES_C: SpriteDef[] = [
  heart,
  candle,
  wax,
  moth,
  lantern,
  match,
  chalice,
  hourglass,
  key,
  lock,
  egg,
  seed,
  ghost,
  sigScratch,
  prize2,
  prize5,
  prize10,
  prize25,
  prizeJackpot,
  prizeDud,
  scratchEye,
];
